// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"eec7ebfe","471":"8ea1bd36","557":"41199757","753":"a1afc029","778":"fdd628ff","825":"3e46a3d2","860":"3e2c6dcc","923":"cd920172"}[chunkId] + ".chunk.css";
};